import _classCallCheck from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/inherits";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import _pt from "prop-types";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import shallowEqual from './utils/shallowEqual';
import updateMultipleDatasetsInView from './utils/updateMultipleDatasetsInView';
import VegaEmbed from './VegaEmbed';
import { NOOP } from './constants';
var EMPTY = {};

var Vega =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Vega, _React$PureComponent);

  function Vega() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Vega);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Vega)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "vegaEmbed", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "handleNewView", function (view) {
      _this.update();

      var _this$props$onNewView = _this.props.onNewView,
          onNewView = _this$props$onNewView === void 0 ? NOOP : _this$props$onNewView;
      onNewView(view);
    });

    return _this;
  }

  _createClass(Vega, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!shallowEqual(this.props.data, prevProps.data)) {
        this.update();
      }
    }
  }, {
    key: "update",
    value: function update() {
      var data = this.props.data;

      if (data) {
        if (this.vegaEmbed.current && Object.keys(data).length > 0) {
          this.vegaEmbed.current.modifyView(function (view) {
            updateMultipleDatasetsInView(view, data);
            view.resize().run();
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          restProps = _objectWithoutPropertiesLoose(_this$props, ["data"]);

      return (
        /*#__PURE__*/
        React.createElement(VegaEmbed, _extends({
          ref: this.vegaEmbed
        }, restProps, {
          onNewView: this.handleNewView
        }))
      );
    }
  }]);

  return Vega;
}(React.PureComponent);

export { Vega as default };

_defineProperty(Vega, "defaultProps", {
  data: EMPTY
});